export const RadialChartStyle = {
  top: '52%',
  right: '1%',
  transform: 'translate(0, -50%)',
  lineHeight: '20px',
  fontSize: '12px'
};

export const PieChartStyle = {
  top: '45%',
  right: '20%',
  transform: 'translate(0, -50%)',
  lineHeight: '20px',
  fontSize: '12px'
};

export const PieChartMultiStyle = {
  top: '52%',
  right: '10%',
  transform: 'translate(0, -50%)',
  lineHeight: '20px',
  fontSize: '12px'
};
